import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const SecureCheckoutWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;

  ${media.xl`
    height: 800px;
  `}
`;

export const SecureCheckoutColumn = styled.div`
  display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.xl`
    display: flex;
    max-width: 50%;
    align-items: flex-start;
  `}
`;

export const SecureCheckoutTitle = styled.h1`
  font-family: ${({ theme }) => theme.headerFont};
  font-size: 35px;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
`;

export const StyledImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
`;

export const LoginMethodList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;

  ${media.xl`
    max-width: 465px;
  `}
`;

export const LoginMethodForm = styled.div`
  flex-direction: column;
  height: auto;
  overflow: hidden;
  padding: 5px;
  margin: -5px;

  ${media.xl`
    max-width: 314px;
  `}
`;

export const LoginMethodItem = styled.li`
  display: flex;
  padding: 15px 15px 20px 15px;
  border: 1px solid
    ${({ theme, isActive }) =>
      isActive ? theme.defaultColors.darkGrey : theme.defaultColors.lightGrey};
  border-radius: 4px;
  margin: 20px 0;

  ${LoginMethodForm} {
    transition: max-height 0.5s ease-in-out;
    max-height: ${({ isActive }) => (isActive ? '350px' : 0)};
    visibility: ${({ isActive }) => (isActive ? 'visible' : 'hidden')};
  }
`;

export const LoginMethodDescription = styled.small`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-size: 15px;
`;

export const LoginMethodItemContent = styled.div`
  width: 100%;
  padding: 5px 10px 0 10px;
`;

export const StyledLabel = styled.label`
  display: block;
  width: 100%;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-family: ${({ theme }) => theme.headerFont};
  cursor: pointer;
  font-size: 18px;
  margin-bottom: 5px;
`;

export const ForgottenPasswordLink = styled.div`
  padding-bottom: 20px;
  font-size: 15px;
`;

export const StyledForm = styled.form`
  display: flex;
  width: 100%;
`;

export const SubmitButtonWrapper = styled.div`
  margin-top: 20px;
`;

export const FormError = styled.div`
  margin: 10px 0px;
`;
